<template>
    <div class="page-container">
        <div class="page-mode-container">
            <div class="page-mode-wrapper">
                <div class="page-mode-item">
                    <div class="mode-title">
                        <div class="mode-title-btn">课程分类</div>
                    </div>
                    <div class="mode-content">
                        <div class="mode-content-item">考试</div>
                        <div class="mode-content-item">实战</div>
                    </div>
                </div>
                <div class="page-mode-item">
                    <div class="mode-title">
                        <div class="mode-title-btn">课程科目</div>
                    </div>
                    <div class="mode-content">
                        <div class="mode-content-item">新政速递</div>
                        <div class="mode-content-item">准则变化</div>
                    </div>
                </div>
                <div class="page-mode-item">
                    <div class="mode-title">
                        <div class="mode-title-btn">专业系列</div>
                    </div>
                    <div class="mode-content">
                        <div class="mode-content-item">2021税收新政</div>
                        <div class="mode-content-item">政府会计准则</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="course-list-container">
            <div class="course-list-wrapper">
                <div v-for="(item,key) in tableData" :key="key" class="course-list-item">
                    <div class="course-list-content">
                        <div class="course-list-img-wrapper">
                            <img src="@/assets/img/v1.png" alt="" class="course-list-img">
                        </div>
                        <div class="course-list-label-wrapper">
                            <div class="course-list-title-item">
                                <div class="course-list-title-label">课程介绍</div>
                                <div class="course-title">
                                    {{item.title}}
                                </div>
                            </div>
                            <div class="course-list-title-item">
                                <div class="course-list-title-label">课程内容</div>
                                <div class="course-list-title-content">
                                    {{item.content}}节
                                </div>
                            </div>
                            <div class="course-list-title-item">
                                <div class="course-list-title-label">学习人数</div>
                                <div class="course-list-title-content">
                                    {{item.person}}
                                </div>
                            </div>
                            <div class="course-list-title-item">
                                <div class="course-list-title-label">课程价格</div>
                                <div class="course-list-title-content">
                                    ￥{{item.price}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="course-list-btn">立即学习</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: '',
    components:{
      
    },
    data() {
        return {
            tableData:[
                {
                    title:'增值税纳税申报比对管理操作规程(试行)',
                    content:13,
                    person:2100,
                    price:1669
                },
                {
                    title:'增值税纳税申报比对管理操作规程(试行)',
                    content:13,
                    person:2100,
                    price:1669
                },
                {
                    title:'增值税纳税申报比对管理操作规程(试行)',
                    content:13,
                    person:2100,
                    price:1669
                },
                {
                    title:'增值税纳税申报比对管理操作规程(试行)',
                    content:13,
                    person:2100,
                    price:1669
                }
            ]
        }
    },
    mounted(){
        scrollTo(0,0);
    },
    methods: {
        
    }
}
</script>

<style scoped>
.page-container{
    padding-top:20px;
    padding-bottom:80px;
}
.page-mode-container{
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #F0F0F3;
    display:flex;
}
.page-mode-wrapper{
    flex:1;
    margin:30px 50px 0px 30px;
}
.page-mode-item{
    display:flex;
    align-items: center;
    margin-bottom:24px;
}
.mode-title{
    margin-right:40px;
}
.mode-title-btn{
    width: 88px;
    height: 38px;
    background: #3E63EE;
    border-radius: 4px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
}
.mode-content{
    display:flex;
    flex-wrap: wrap;
}
.mode-content-item{
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    margin-right:40px;
}
.mode-content-item:hover{
    cursor: pointer;
}
.course-list-container{
    display:flex;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #F0F0F3;
    margin-top:20px;
}
.course-list-wrapper{
    flex:1;
    margin:28px 30px 80px 30px;
}
.course-list-item{
    display:flex;
    justify-content: space-between;
    padding:30px 0px 30px 0px;
    border-bottom:solid #F0F0F0 1px;
}
.course-list-img-wrapper{
    width:242px;
    height:150px;
}
.course-list-img{
    width:100%;
    height:100%;
}
.course-list-btn{
    width: 108px;
    height: 40px;
    background: #3E63EE;
    border-radius: 6px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top:50px;
}
.course-list-btn:hover{
    cursor: pointer;
    opacity:0.8;
}
.course-list-content{
    display:flex;
}
.course-list-label-wrapper{
    margin-left:34px;
}
.course-list-title-item{
    display:flex;
    margin-bottom:12px;
}
.course-list-title-label{
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #606A74;
    margin-right:34px;
}
.course-list-title-content{
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #606A74;
}
.course-title{
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
}
</style>


